import * as React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../../../codegen/Localize';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const METRICS_CONTENT_TYPE_FIELD = 'settings.metricsContentTypeEnabled';

export type MetricsContentTypeSectionProps = SiteSettingsForSiteAdminProps<'metricsContentTypeEnabled'>;

export function MetricsContentTypeSection(props: MetricsContentTypeSectionProps) {
  return FeatureFlags.metricsContentTypeSiteSettingEnabled
  ? (
    <SettingsSection title={Messages.metricsContentTypeSiteSetting()}
                     description={Messages.metricsContentTypeSiteSettingDescription()}
                     testId={'metrics-content-type-setting-section'}>
      <FormikCheckbox name={METRICS_CONTENT_TYPE_FIELD}
                      label={Messages.metricsContentTypeSiteSettingEnable()}
                      testId={'metrics-content-type-enabled'}/>
    </SettingsSection>
    )
    : null;
}

export const MetricsContentTypeSpecs = componentRegistryEntry({
  name: 'MetricsContentTypeSection',
  component: MetricsContentTypeSection
});
